import { useCallback } from 'react';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const useSignup = () => {
    const signupRedirect = useCallback(async (redirectPath?: string) => {
        if (redirectPath) {
            sessionStorage.setItem('auth.redirectPath', redirectPath);
        }

        // Create a separate UserManager specifically for signup
        const signupManager = new UserManager({
            authority: `https://cognito-idp.us-east-2.amazonaws.com/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`,
            client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
            redirect_uri: `${import.meta.env.VITE_REDIRECT_URI}/auth/callback`,
            response_type: 'code',
            scope: 'email openid phone profile',
            automaticSilentRenew: false,
            loadUserInfo: false,
            // Use a different storage prefix to avoid conflicts
            userStore: new WebStorageStateStore({
                store: window.sessionStorage,
                prefix: 'oidc.'
            }),
            metadata: {
                issuer: import.meta.env.VITE_COGNITO_DOMAIN,
                authorization_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/signup`,
                token_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/oauth2/token`,
                userinfo_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/oauth2/userInfo`,
                end_session_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/logout`,
                jwks_uri: `${import.meta.env.VITE_COGNITO_DOMAIN}/.well-known/jwks.json`,
            }
        });

        await signupManager.signinRedirect();
    }, []);

    return { signupRedirect };
};